import React from 'react';
import cn from "classnames";
import styles from "./banner-info.css";

const BannerInfo = ({title, cover, desc, buttons, style}) => {
    return (
        <div className={cn(styles.antRow, styles.banner)} style={style}>
            <div className={cn(styles.antCol, styles.antCol8, styles.cover)}>
                <img src={`https://oss.pkcode.cn/scratch/cover/course/${cover}.png`} onError={e => {e.target.onError = null;e.target.src="https://oss.pkcode.cn/scratch/cover/course/default.png"}}  />
            </div>
            <div className={cn(styles.antCol, styles.antCol16, styles.info)}>
                <h2>{title}</h2>
                <p>
                    {desc}
                </p>
                <div className={styles.buttons}>
                    {buttons}
                </div>
            </div>
        </div>
    )
};

export default BannerInfo;
